import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  standalone: true,
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: Date): string {
    const time = new Date(value);
    const now = new Date();
    const seconds = Math.floor((now.getTime() - time.getTime()) / 1000);

    const getDayWithSuffix = (day: number): string => {
      if (day > 3 && day < 21) return `${day}th`;
      switch (day % 10) {
        case 1:
          return `${day}st`;
        case 2:
          return `${day}nd`;
        case 3:
          return `${day}rd`;
        default:
          return `${day}th`;
      }
    };

    if (seconds < 60) return 'just now';
    if (seconds < 120) return 'a minute ago';
    if (seconds < 3600) return `${Math.floor(seconds / 60)} minutes ago`;
    if (seconds < 7200) return 'an hour ago';
    if (seconds < 86400) return `${Math.floor(seconds / 3600)} hours ago`;

    const day = time.getDate();
    const month = time.toLocaleString('default', { month: 'short' });
    const year = time.getFullYear();
    return `${getDayWithSuffix(day)} ${month} ${year}`;
  }
}
